export const downloadArquivo = 'DownloadArquivo';
export const uploadArquivo = 'UploadNovoArquivo';
export const exportarArquivos = 'ExportarArquivos';
export const listarArquivos = 'ListarArquivos';

export const arquivos = {
  status: [downloadArquivo, exportarArquivos, listarArquivos],
  upload: [uploadArquivo]
};
